<template>
  <v-widget title="Trainer Terbanyak">
    <div slot="widget-content">
      <div
        v-if="!trainer_divisi_loaded"
        class="layout justify-center align-center"
        style="padding: 200px 0"
      >
        <v-progress-circular
          indeterminate
          :size="40"
          :width="2"
          color="secondary"
        >
        </v-progress-circular>
      </div>
      <div v-else-if="divisiData.datasets.length">
        <!-- <e-chart :path-option="[
                  ['dataset.source', divisiData],
                  ['legend.bottom', '0'],
                  ['legend.textStyle.color', $vuetify.dark ? color.shades.white : color.shades.black],
                  ['color', colors],
                  ['xAxis.show', false],
                  ['yAxis.show', false],
                  ['series[0].type', 'pie'],
                  ['series[0].avoidLabelOverlap', true],
                  ['series[0].radius', ['0%', '30%']],
                ]"
                 height="400px"
                 width="100%">
        </e-chart> -->
        <doughnut-chart :chartData="divisiData"> </doughnut-chart>
      </div>
      <div
        v-else
        class="layout justify-center align-center"
        style="padding: 200px 0"
      >
        <h2>Belum ada data.</h2>
        <v-icon medium>sentiment_very_dissatisfied</v-icon>
      </div>
    </div>
  </v-widget>
</template>

<script>
import _ from "lodash";
import Material from "vuetify/es5/util/colors";
import VWidget from "@/components/widgets/VWidget";
// import EChart from "@/components/chart/echart";
import DoughnutChart from "@/components/chart/DoughnutChart";
import { mapState } from "vuex";

export default {
  name: "most-divisi",
  components: {
    VWidget,
    // EChart
    DoughnutChart
  },
  data() {
    return {
      color: Material,
      colors: [
        Material.red.base,
        Material.orange.base,
        Material.teal.base,
        Material.purple.base,
        Material.pink.base,
        Material.green.base,
        Material.indigo.base,
        Material.cyan.base,
        Material.yellow.base,
        Material.blue.base,
        Material.brown.base,
        Material.lime.base
      ]
    };
  },
  computed: {
    ...mapState("trainer_divisi", ["trainer_divisi_loaded"]),
    divisiData() {
      let divisi = _.orderBy(
        this.$store.state.trainer_divisi.trainer_divisi,
        o => {
          return parseInt(o.total_trainer);
        },
        ["desc"]
      );
      // return divisi.map(dv => {
      //   return {
      //     Trainer: dv.trainer_divisi,
      //     value: parseInt(dv.total_trainer)
      //   };
      // });

      return {
        labels: divisi.map(ar => {
          return ar.trainer_divisi;
        }),
        datasets: [
          {
            data: divisi.map(ar => {
              return parseInt(ar.total_trainer);
            }),
            backgroundColor: this.colors
          }
        ]
      };
    }
  }
};
</script>
